import { parseAsBoolean, useQueryState } from 'nuqs';
import { useCallback, useEffect, useState } from 'react';

export const DEBUG_MODE_STORAGE_KEY = 'debug';

export const readStoredDebugMode = () => {
  if (typeof window === 'undefined') return false;

  try {
    return window.localStorage.getItem(DEBUG_MODE_STORAGE_KEY) !== null;
  } catch {
    return false;
  }
};

export const persistDebugMode = (isDebug: boolean) => {
  if (typeof window === 'undefined') return;

  try {
    if (isDebug) {
      window.localStorage.setItem(DEBUG_MODE_STORAGE_KEY, 'true');
      return;
    }

    window.localStorage.removeItem(DEBUG_MODE_STORAGE_KEY);
  } catch {
    // Ignore storage failures; the URL state still controls the current render.
  }
};

export const useDebugMode = () => {
  const [queryDebug, setQueryDebug] = useQueryState('debug', parseAsBoolean);
  const [storedDebug, setStoredDebug] = useState(readStoredDebugMode);

  useEffect(() => {
    if (queryDebug === null) return;

    persistDebugMode(queryDebug);
    setStoredDebug(queryDebug);
  }, [queryDebug]);

  const setDebugMode = useCallback(
    (nextDebug: boolean) => {
      persistDebugMode(nextDebug);
      setStoredDebug(nextDebug);
      void setQueryDebug(nextDebug);
    },
    [setQueryDebug]
  );

  return [queryDebug ?? storedDebug, setDebugMode] as const;
};

export default useDebugMode;
